export interface PedidoCompra {
  CC7FILIAL: string,
  CC7NUM: string,
  CC7FORNECE: string,
  CC7LOJA: string,
  CC7SOLICIT: string,
  CC7USER: string,
  CC7COND: string,
  CC7FILENT: string,
  NC7MOEDA: number,
  NC7TXMOEDA: number,
  DC7EMISSAO: Date | undefined;

  items : Array<PedidoCompraItem>;
}
export interface PedidoCompraItem {
  CC7ITEM: string;
  CC7PRODUTO: string;
  CB1DESC: string;
  CC7DESCRI: string;
  CC7OBS: string;
  CC7UM: string;
  CC7TES: string;
  CC7SEGUM: string;
  CC7LOCAL: string;
  CC7RESIDUO: string;
  CC7CC: string;
  CCTTDESC01: string;
  CC7CONTA: string;
  CCT1DESC01: string;
  CC7NUMSC: string;
  CC7ITEMSC: string;
  CC7HSENV: string;
  CSITUACAO: string;
  CC7ZCDNEGO: string;
  NC7PRECO: number;
  NC7QUANT: number;
  NC7TOTAL: number;
  NC7QUJE: number;
  NC7QTSEGUM: number;
  NC7QTDSOL: number;
  DC7DATPRF: Date | undefined;
  DC7DTENV: Date | undefined;
}

export const defaultPedidoCompra = (): PedidoCompra => {
  return{
    CC7FILIAL: '',
    CC7NUM: '',
    CC7FORNECE: '',
    CC7LOJA: '',
    CC7SOLICIT: '',
    CC7USER: '',
    CC7COND: '',
    CC7FILENT: '01',
    NC7MOEDA: 1,
    NC7TXMOEDA: 0,
    DC7EMISSAO: new Date(),
    items: [],
  };
};

export const defaultPedidoCompraItem = (): PedidoCompraItem => {
  return{
    CC7ITEM: '',
    CC7PRODUTO: '',
    CB1DESC: '',
    CC7DESCRI: '',
    CC7OBS: '',
    CC7UM: '',
    CC7TES: '',
    CC7SEGUM: '',
    CC7LOCAL: '',
    CC7RESIDUO: '',
    CC7CC: '',
    CCTTDESC01: '',
    CC7CONTA: '',
    CCT1DESC01: '',
    CC7NUMSC: '',
    CC7ITEMSC: '',
    CC7HSENV: '',
    CSITUACAO: '',
    CC7ZCDNEGO: '',
    NC7PRECO: 0,
    NC7QUANT: 0,
    NC7TOTAL: 0,
    NC7QUJE: 0,
    NC7QTSEGUM: 0,
    NC7QTDSOL: 0,
    DC7DATPRF:  undefined,
    DC7DTENV:  undefined,
  }
}

export interface PedidoCompraLista {
  items: Array<PedidoCompraListaItem>;
  hasNext: boolean;
}

export interface PedidoCompraListaItem {
  CC7FILIAL: string;
  CC7NUM: string;
  CC7FORNECE: string;
  CC7LOJA: string;
  CC7SOLICIT: string;
  CC7USER: string;
  DC7EMISSAO: Date | undefined;
  CA2NOME: string;
  CA2CGC: string;

  items: Array<PedidoCompraItem>
}

export interface PedidoCompraEnviarEmailFornecedor {
  CC7NUM: string;
  COBSERVACAO: string;
}

export const defaultPedidoCompraEnviarEmailFornecedor = (): PedidoCompraEnviarEmailFornecedor => {
  return{
    CC7NUM: '',
    COBSERVACAO: '',
  };
};
